<template>
  <TitledInputField
    :inputLabel="inputLabel"
    :iconName="iconName"
    :tooltipText="tooltipText"
  >
    <template #inputComponent>
      <ThemedTextField
        :value="value"
        :rules="rules"
        @input="onChange"
        type="number"
        hide-details="auto"
        outlined
        :step="step"
        :disabled="disabled"
      ></ThemedTextField>
    </template>
  </TitledInputField>
</template>

<script>
import TitledInputField from "./TitledInputField.vue";
import ThemedTextField from "../../../core/ThemedTextField.vue";
export default {
  name: "TitledNumericalInputField",
  components: {
    TitledInputField,
    ThemedTextField,
  },
  props: {
    inputLabel: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
    tooltipText: {
      type: String,
      default: null,
    },
    iconName: {
      type: String,
      default: "mdi-windsock",
    },
    onChange: {
      type: Function,
      required: true,
    },
    rules: {
      type: Array[Function],
      default() {
        return [];
      },
    },
    step: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
